// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers'

import {Paper} from './paper.js'

export class SetPaper {
  bb: flatbuffers.ByteBuffer | null = null
  bb_pos = 0
  __init(i: number, bb: flatbuffers.ByteBuffer): SetPaper {
    this.bb_pos = i
    this.bb = bb
    return this
  }

  static getRootAsSetPaper(bb: flatbuffers.ByteBuffer, obj?: SetPaper): SetPaper {
    return (obj || new SetPaper()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  static getSizePrefixedRootAsSetPaper(bb: flatbuffers.ByteBuffer, obj?: SetPaper): SetPaper {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH)
    return (obj || new SetPaper()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  value(obj?: Paper): Paper | null {
    const offset = this.bb!.__offset(this.bb_pos, 4)
    return offset ? (obj || new Paper()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null
  }

  static startSetPaper(builder: flatbuffers.Builder) {
    builder.startObject(1)
  }

  static addValue(builder: flatbuffers.Builder, valueOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, valueOffset, 0)
  }

  static endSetPaper(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject()
    return offset
  }

  static createSetPaper(builder: flatbuffers.Builder, valueOffset: flatbuffers.Offset): flatbuffers.Offset {
    SetPaper.startSetPaper(builder)
    SetPaper.addValue(builder, valueOffset)
    return SetPaper.endSetPaper(builder)
  }
}
